import {
  Box,
  Paper,
  Stack,
  SwipeableDrawer,
  Typography,
  useMediaQuery,
  IconButton,
  Avatar,
} from "@mui/material";
import ticket_top from "../../../assets/images/ticket_top.svg";
import export_campaign from "../../../assets/icons/export_campaign.svg";
import event_cancel from "../../../assets/icons/preveiw_cancel.svg";
import green_tick from "../../../assets/icons/green_tick.svg";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { memo, useEffect, useState } from "react";
import ReplyIcon from '@mui/icons-material/Reply';
const TextWithLineBreaks = (props) => {
  const { template, campaign_data } = props;
  const textWithBreaks = props.template.meta_template_data?.components?.find((it) => it.type == 'BODY')?.text
    .split("\n")
    .map((text, index) => {
      let newText = text;
      let matches = text.match(/{{(\d+)}}/g);
      // hello -- first line
      if (matches) {
        matches.forEach((match) => {
          const key = match.slice(2, -2); // Extract the key from {{key}}
          const variable = template?.template_data?.variables?.body.find(
            (item) => item.key_value == key && item.type === "DYNAMIC"
          );

          if (variable) {
            // assign the name given by the backend
            newText = newText.replace(match, variable.fallback_value);
          } else {
            // assign the name given by the endures form the dynamic template
            const campaignVariable = campaign_data.body.find(
              (item) => Object.keys(item)[0] === key
            );

            if (campaignVariable) {
              newText = newText.replace(match, campaignVariable[key]);
            }
          }
        });
      }
      // Convert text enclosed in * to bold
      newText = newText.replace(/\*(.*?)\*/g, "<b>$1</b>");

      return (
        <Typography
          mt={1}
          variant="body2"
          fontSize="12px"
          fontWeight={400}
          key={index}
          dangerouslySetInnerHTML={{ __html: newText }}
        />
      );
    });

  return <div>{textWithBreaks}</div>;
};

const CampaignPreView = ({
  template,
  campaign_data,
  image,
  toggleDrawer,
  anchor,
  state,
  mediaType,
  templateHeader
}) => {

  const matches = useMediaQuery("(min-width:1100px)");
  const key =
    campaign_data?.header?.[0] && Object.keys(campaign_data?.header?.[0]);

  const image_src = image ? image : campaign_data?.header[0]?.[key?.[0]];

  const type = campaign_data?.header[0]?.mediaType;
  const [videoData, setVideoData] = useState();

  useEffect(() => {
    if (type == "video") {
      setVideoData(typeof image_src == "string" ? image_src : URL.createObjectURL(image_src))

    }
  }, [image_src]);



  const buttons = template?.meta_template_data?.components.find((it) => it.type == "BUTTONS")
  return (
    <>
      {" "}
      {matches ? (
        <Stack spacing={2} alignItems="center">
          {!key && <Typography variant="h4">Template Preview</Typography>}
          <Box
            sx={{
              mt: 1,
              borderRadius: "22px",
              border: "8px solid #2A2A2A",
              background: "#FFF",
              width: "278px",
              minHeight: "400px",
            }}
          >
            <Stack height="100%" borderRadius="14px" bgcolor="#D9D2CA">
              {templateHeader?.waba_name ? <Box sx={{
                padding: "25px 10px 10px 10px", background: "#008069", borderTopLeftRadius: "14px",
                borderTopRightRadius: "14px",
              }}>
                <Stack direction="row" gap="10px" alignItems="center">
                  <KeyboardBackspaceIcon sx={{ color: "white", fontSize: "20px" }} />
                  <Avatar alt="Remy Sharp" src={templateHeader?.profile_img} sx={{ width: "30px", height: "30px" }} />
                  <Stack direction="row" gap="5px" alignItems="center">
                    <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "white" }}>{templateHeader?.waba_name}</Typography>
                    <img src={green_tick} style={{ width: "15px" }} />
                  </Stack>
                </Stack>
              </Box> :
                <Box
                  component="img"
                  sx={{
                    borderTopLeftRadius: "14px",
                    borderTopRightRadius: "14px",
                    ml: "-2px",
                  }}
                  width="101.5%"
                  src={ticket_top}
                  zIndex={10}
                />
              }
              <Stack
                sx={{
                  overflowY: "scroll",
                  "&::-webkit-scrollbar": {
                    width: "0px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#0276E5",
                  },
                  borderBottomLeftRadius: "14px",
                  borderBottomRightRadius: "14px",
                }}
                height="100%"
              >
                <Paper>
                  <Stack
                    sx={{
                      gap: "0.5rem",
                      borderRadius: "8px",
                    }}
                  >
                    <Stack gap="0.6rem" p={"0.5rem  "}>
                      {/* {(image || key) && (
                        <Box borderRadius="5.703px" width="100%">
                          {mediaType === "image" ? (
                            image && (
                              <img
                                src={image_src}
                                alt="Selected"
                                style={{
                                  width: "100%",
                                  borderRadius: "5.703px",
                                }}
                              />
                            )
                          ) : (
                            <video
                              src={image_src}
                              alt="Selected"
                              style={{
                                width: "100%",
                                borderRadius: "5.703px",
                              }}
                              controls
                            />
                          )}
                        </Box>
                      )} */}
                      {(image || key && (type == "image" || !type)) && (
                        <Box borderRadius="5.703px" width="100%">
                          {
                            <img
                              src={image_src}
                              alt="Selected"
                              style={{
                                width: "100%",
                                borderRadius: "5.703px",
                              }}
                            />
                          }
                        </Box>
                      )}
                      {(type == "video" && image_src) && (
                        <Box borderRadius="5.703px" width="100%">
                          {
                            <video
                              src={typeof image_src == "string" ? image_src : videoData}
                              alt="Selected"
                              style={{
                                width: "100%",
                                borderRadius: "5.703px",
                              }}
                              controls

                            />
                          }
                        </Box>
                      )}
                      {type == "text" && (
                        <Typography variant="h5">{image_src}</Typography>
                      )}

                      {template && (
                        <TextWithLineBreaks
                          template={template}
                          campaign_data={campaign_data}
                        />
                      )}
                      {/* { template?.template_data?.variables?.button[0]   &&(

                )} */}
                      <Typography
                        variant="body2"
                        fontSize="12px"
                        fontWeight={400}
                        color="#838383"
                      >
                        Send STOP to unsubscribe | Powered by <span style={{ fontWeight: 700 }}>ticketsque.com</span>
                      </Typography>
                    </Stack>
                    {
                      buttons?.buttons?.map((it, index) => {
                        return (
                          <Stack
                            key={index}
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            gap={0.5}
                            p={0.5}
                            width="100%"
                            borderTop="0.01px solid rgba(167, 164, 164, 0.5)"
                          >
                            {
                              it?.text == "Chat with us" ?
                                <ReplyIcon color="primary" /> :
                                <Box component="img" src={export_campaign} />
                            }

                            <Typography
                              fontSize="14px"
                              color={"#0276E5"}
                              variant="body2"
                            >
                              {
                                it?.text
                              }
                            </Typography>
                          </Stack>
                        )
                      })
                    }
                  </Stack>
                </Paper>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      ) : (
        <SwipeableDrawer
          anchor={anchor}
          open={state[anchor]}
          onClose={toggleDrawer(anchor, false)}
          onOpen={toggleDrawer(anchor, true)}
        >
          <Stack spacing={2} p="0.5rem 1.5rem" maxHeight="70vh">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h3" color="primary">
                {" "}
                Preveiw{" "}
              </Typography>
              <IconButton onClick={toggleDrawer(anchor, false)}>
                <Box component="img" src={event_cancel} />
              </IconButton>
            </Stack>
            <Stack direction="row" width="100%" justifyContent="center">
              <Stack spacing={2} alignItems="center">
                {!key && <Typography variant="h4">Template Preview</Typography>}
                <Box
                  sx={{
                    mt: 1,
                    borderRadius: "22px",
                    border: "8px solid #2A2A2A",
                    background: "#FFF",
                    width: "278px",
                    height: "600px",
                  }}
                >
                  <Stack height="100%" borderRadius="14px" bgcolor="#D9D2CA">
                    <Box
                      component="img"
                      sx={{
                        borderTopLeftRadius: "14px",
                        borderTopRightRadius: "14px",
                        ml: "-2px",
                      }}
                      width="101.5%"
                      src={ticket_top}
                      zIndex={99999}
                    />
                    <Stack
                      sx={{
                        overflowY: "scroll",
                        "&::-webkit-scrollbar": {
                          width: "0px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#0276E5",
                        },
                        borderBottomLeftRadius: "14px",
                        borderBottomRightRadius: "14px",
                      }}
                      height="100%"
                    >
                      <Paper>
                        <Stack
                          sx={{
                            gap: "0.5rem",
                            borderRadius: "8px",
                          }}
                        >
                          <Stack gap="0.6rem" p={"0.5rem  "}>
                            {(image || key && (type == "image" || !type)) && (
                              <Box borderRadius="5.703px" width="100%">
                                {
                                  <img
                                    src={image_src}
                                    alt="Selected"
                                    style={{
                                      width: "100%",
                                      borderRadius: "5.703px",
                                    }}
                                  />
                                }
                              </Box>
                            )}
                            {(type == "video" && image_src) && (
                              <Box borderRadius="5.703px" width="100%">
                                {
                                  <video
                                    src={typeof image_src == "string" ? image_src : videoData}
                                    alt="Selected"
                                    style={{
                                      width: "100%",
                                      borderRadius: "5.703px",
                                    }}
                                    controls

                                  />
                                }
                              </Box>
                            )}
                            {type == "text" && (
                              <Typography variant="h5">{image_src}</Typography>
                            )}
                            {template && (
                              <TextWithLineBreaks
                                template={template}
                                campaign_data={campaign_data}
                              />
                            )}
                            {/* { template?.template_data?.variables?.button[0]   &&(

                )} */}
                            <Typography
                              variant="body2"
                              fontSize="12px"
                              fontWeight={400}
                              color="#838383"
                            >
                              Send STOP to unsubscribe | Powered by <span style={{ fontWeight: 700 }}>ticketsque.com</span>
                            </Typography>
                          </Stack>
                          {/* <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            gap={0.5}
                            p={0.5}
                            width="100%"
                            borderTop="0.01px solid rgba(167, 164, 164, 0.5)"
                          >
                            <Box component="img" src={export_campaign} />
                            <Typography
                              fontSize="14px"
                              color="#5996F6"
                              variant="body2"
                            >
                              {
                                template?.meta_template_data?.components[3]
                                  ?.buttons[0]?.text
                              }
                            </Typography>
                          </Stack> */}
                          {
                            buttons?.buttons?.map((it, index) => {
                              return (
                                <Stack
                                  key={index}
                                  direction="row"
                                  justifyContent="center"
                                  alignItems="center"
                                  gap={0.5}
                                  p={0.5}
                                  width="100%"
                                  borderTop="0.01px solid rgba(167, 164, 164, 0.5)"
                                >
                                  {
                                    it?.text == "Chat with us" ?
                                      <ReplyIcon color="primary" /> :
                                      <Box component="img" src={export_campaign} />
                                  }
                                  <Typography
                                    fontSize="14px"
                                    color={"#0276E5"}
                                    variant="body2"
                                  >
                                    {
                                      it?.text
                                    }
                                  </Typography>
                                </Stack>
                              )
                            })
                          }

                        </Stack>
                      </Paper>
                    </Stack>
                  </Stack>
                </Box>
              </Stack>
            </Stack>
          </Stack>
        </SwipeableDrawer>
      )}
    </>
  );
};
export default memo(CampaignPreView);
